import { Component, inject, Inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatRipple } from '@angular/material/core';
import { MatIconButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
  MatOption,
} from '@angular/material/autocomplete';

import { map, Observable, startWith } from 'rxjs';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';

import { AuthService } from 'src/app/core/services/auth.service';
import { GoogleAnalyticService } from 'src/app/core/services/google-analytic.service';

@Component({
  selector: 'app-hotel-search',
  imports: [
    MatFormField,
    MatIcon,
    MatIconButton,
    MatInput,
    AsyncPipe,
    MatAutocomplete,
    MatOption,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatRipple,
  ],
  templateUrl: './hotel-search.component.html',
  styleUrl: './hotel-search.component.scss',
})
export class HotelSearchComponent {
  public searchControl: FormControl = new FormControl('');
  public filteredHotels: Observable<any[]>;

  protected readonly eSvgIcons = ESvgIcons;

  #hotelId: number = 0;
  #authService = inject(AuthService);
  #googleAnalyticService = inject(GoogleAnalyticService);
  #dialogRef = inject(MatDialogRef<HotelSearchComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) private hotels: any[]) {
    this.filteredHotels = this.searchControl.valueChanges.pipe(
      startWith(''),
      map((value: string) => this._filter(value || '')),
    );
  }

  get isSearchEnabled(): boolean {
    return !this.#hotelId;
  }

  selectHotel(hotelId: number): void {
    this.#hotelId = hotelId;
  }

  clearSearch(ev: Event): void {
    ev.stopPropagation();
    this.#hotelId = 0;
    this.searchControl.setValue('', { onlySelf: true });
  }

  submit(): void {
    this.#dialogRef.close(this.#hotelId);
  }

  close(): void {
    this.#dialogRef.close();
  }

  setGoogleAnalytic() {
    const firstHotel = this.hotels[0];
    this.#googleAnalyticService.setHotelAnalytic({
      activityName: 'Banner',
      activityType: 'Banner',
      countryName: firstHotel?.countryCode || 'NA',
      cityName: firstHotel?.cityId || 'NA',
      userID: this.#authService.userId,
    });
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.hotels.filter((option) =>
      option.name.toLowerCase().includes(filterValue),
    );
  }
}
